import { Div2Floor } from "../utils/Div2Floor";
import { QDivider } from "./QDivider";
import { QStaticText } from "./QStaticText";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";

export class QDividerText extends QStaticText {
  constructor() {
    super();
  }

  InitDividerText() {
    this.InitStaticText();
  }

  DoRenderElement(drawBuffer) {
    var txtFillStyle = this.GetTextColor();
    this.SetPadding(16);
    this.RenderText(drawBuffer, txtFillStyle);

    var txtWidth = this.CalcMinWidth();
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    var thickness = 1;
    var h = this.GetHeight();
    var w = this.GetWidth();
    ctx.globalAlpha = 0.65;
    ctx.strokeStyle = this.fLineColor ? this.fLineColor : "#DDDDDD";
    ctx.lineWidth = thickness;
    ctx.lineCap = "square";

    var xStart = txtWidth - 8;
    var sx = this.fHorzOffset + xStart;
    // 	var sy = this.fVertOffset + Math.floor(h/2) + ThicknessAdjuster(thickness);
    var sy = this.fVertOffset + Div2Floor(h) + ThicknessAdjuster(thickness);
    var ex = this.fHorzOffset + w;

    ctx.beginPath();
    ctx.moveTo(this.fHorzOffset, sy);
    ctx.lineTo(this.fHorzOffset + this.fPaddingX - 8, sy);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(ex, sy);
    ctx.stroke();
    ctx.globalAlpha = 1;
    ctx.restore();
  }

  SetLineColor(lineColor) {
    this.fLineColor = lineColor;
  }

  GetElementWidth() {
    return this.GetWidth();
  }
}
